import React from "react";

import "./ProcessTable.css";

import MillingTable from "../../../common/MillingTable";
import BoringTable from "../../../common/BoringTable";
import DrillingTable from "../../../common/DrillingTable";
import TappingTable from "../../../common/TappingTable";

export const ProcessTable = ({
  data,
  handleTextFieldChange,
  handleIdleTimeChange,
  processTableErrors,
  containerIndex,
  selectedProcessName,
  calculateCT,
  handleDeleteConfirm,
  addIdleCode,
  deleteModalState,
  handleDeleteCancel,
  handleDeleteClick,
  calculateTimeDifference,
}) => {
  const processTableData = data || [];

  return (
    <>
      {selectedProcessName === "Milling" && (
        <MillingTable
          processTableData={processTableData}
          handleTextFieldChange={handleTextFieldChange}
          handleIdleTimeChange={handleIdleTimeChange}
          processTableErrors={processTableErrors}
          containerIndex={containerIndex}
          calculateCT={calculateCT}
          handleDeleteConfirm={handleDeleteConfirm}
          addIdleCode={addIdleCode}
          deleteModalState={deleteModalState}
          handleDeleteCancel={handleDeleteCancel}
          handleDeleteClick={handleDeleteClick}
          calculateTimeDifference={calculateTimeDifference}
        />
      )}
      {selectedProcessName === "Drilling" && (
        <DrillingTable
          processTableData={processTableData}
          handleTextFieldChange={handleTextFieldChange}
          handleIdleTimeChange={handleIdleTimeChange}
          processTableErrors={processTableErrors}
          containerIndex={containerIndex}
          calculateCT={calculateCT}
          handleDeleteConfirm={handleDeleteConfirm}
          addIdleCode={addIdleCode}
          deleteModalState={deleteModalState}
          handleDeleteCancel={handleDeleteCancel}
          handleDeleteClick={handleDeleteClick}
          calculateTimeDifference={calculateTimeDifference}
        />
      )}
      {selectedProcessName === "Boring" && (
        <BoringTable
          processTableData={processTableData}
          handleTextFieldChange={handleTextFieldChange}
          handleIdleTimeChange={handleIdleTimeChange}
          processTableErrors={processTableErrors}
          containerIndex={containerIndex}
          calculateCT={calculateCT}
          handleDeleteConfirm={handleDeleteConfirm}
          addIdleCode={addIdleCode}
          deleteModalState={deleteModalState}
          handleDeleteCancel={handleDeleteCancel}
          handleDeleteClick={handleDeleteClick}
          calculateTimeDifference={calculateTimeDifference}
        />
      )}
      {selectedProcessName === "Tapping" && (
        <TappingTable
          processTableData={processTableData}
          handleTextFieldChange={handleTextFieldChange}
          handleIdleTimeChange={handleIdleTimeChange}
          processTableErrors={processTableErrors}
          containerIndex={containerIndex}
          calculateCT={calculateCT}
          handleDeleteConfirm={handleDeleteConfirm}
          addIdleCode={addIdleCode}
          deleteModalState={deleteModalState}
          handleDeleteCancel={handleDeleteCancel}
          handleDeleteClick={handleDeleteClick}
          calculateTimeDifference={calculateTimeDifference}
        />
      )}
      {/* Add conditional rendering for other process tables as needed */}
    </>
  );
};
